import { render, staticRenderFns } from "./FormaDataEdit.vue?vue&type=template&id=52a7e348&scoped=true&"
import script from "./FormaDataEdit.vue?vue&type=script&lang=js&"
export * from "./FormaDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7e348",
  null
  
)

export default component.exports